module.exports = __webpack_public_path__ + "static/media/gallup.4bb182e4.svg";